import { ResellerSettingsDTO } from '@/core/api/dtos/response/users/resellerSettings'
import { ResellerSettings } from '@/core/api/entities/user/resellerSettings'

export class ResellerSettingsMapper {
	static toEntity(dto: ResellerSettingsDTO): ResellerSettings {
		return ResellerSettings.create({
			myBrandtrack: {
				billingSectionEnabled: dto.my_brandtrack.billing_section_enabled,
				zoneCreateEnabled: dto.my_brandtrack.zone_create_enabled,
				zoneEditEnabled: dto.my_brandtrack.zone_edit_enabled,
				zoneDeleteEnabled: dto.my_brandtrack.zone_delete_enabled,
				zoneRefreshEnabled: dto.my_brandtrack.zone_refresh_enabled,
				zoneViewPlaylistsEnabled: dto.my_brandtrack.zone_view_playlists_enabled,
				zoneInstallationInfoEnabled:
					dto.my_brandtrack.zone_installation_info_enabled,
				zoneEventsNumber: dto.my_brandtrack.zone_events_number,
				locationEditEnabled: dto.my_brandtrack.location_edit_enabled,
				locationDeleteEnabled: dto.my_brandtrack.location_delete_enabled,
				locationShareEnabled: dto.my_brandtrack.location_share_enabled,
				groupFeatureEnabled: dto.my_brandtrack.group_feature_enabled,
				radioUnlimitedSongs: dto.my_brandtrack.radio_unlimited_songs,
				radioLastTimeUpdatedEnabled:
					dto.my_brandtrack.radio_last_time_updated_enabled,
				radioAssignPlaylistEnabled:
					dto.my_brandtrack.radio_assign_playlist_enabled,
				radioDeletedSongsEnabled: dto.my_brandtrack.radio_deleted_songs_enabled,
				radioDiscoverEnabled: dto.my_brandtrack.radio_discover_enabled,
				radioAddCustomEnabled: dto.my_brandtrack.radio_add_custom_enabled,
				radioFeedbackEnabled: dto.my_brandtrack.radio_feedback_enabled,
				radioModifyPlaylistEnabled:
					dto.my_brandtrack.radio_modify_playlist_enabled,
				radioRatePlaylistEnabled: dto.my_brandtrack.radio_rate_playlist_enabled,
				musicProfileFeatureEnabled:
					dto.my_brandtrack.music_profile_feature_enabled,
				campaignCreateEnabled: dto.my_brandtrack.campaign_create_enabled,
				campaignCreateAiEnabled: dto.my_brandtrack.campaign_create_ai_enabled,
				campaignCreateAiCustomDescription:
					dto.my_brandtrack.campaign_create_ai_custom_description,
				campaignEditEnabled: dto.my_brandtrack.campaign_edit_enabled,
				campaignDeleteEnabled: dto.my_brandtrack.campaign_delete_enabled,
				accountMusicLegalComplianceEnabled:
					dto.my_brandtrack.account_music_legal_compliance_enabled,
				integrationsFeatureEnabled:
					dto.my_brandtrack.integrations_feature_enabled,
				privacyPolicyEnabled: dto.my_brandtrack.privacy_policy_enabled,
				dataDeletionEnabled: dto.my_brandtrack.data_deletion_enabled,
				registratonEnabled: dto.my_brandtrack.registraton_enabled,
			},
			directlyInvoiced: dto.directly_invoiced,
			resellerName: dto.reseller_name,
			resellerId: dto.reseller_id,
		})
	}

	static toEntities(dtos: ResellerSettingsDTO[]): ResellerSettings[] {
		return dtos.map(this.toEntity)
	}
}
